import React from "react";
import SearchableCombobox from "@/components/SearchableCombobox";

/**
 * Searchable picker for inventory items — used by Stock movements, PR/PO line
 * items, Production Run FG picker, etc.
 *
 * Dedupes by item code (fallback: lowercased name). The secondary line shows
 * `code · uom` plus available_qty when available. Search covers name, code,
 * HSN and barcode.
 */
export default function InventoryItemCombobox({
  items = [],
  value = "",
  onPick,
  testId = "inv-item-combobox",
  placeholder = "Search item…",
  className = "",
  disabled = false,
  category,           // optional filter — e.g. "finished_goods" for FG-only pickers
  showAvailability = true,
}) {
  const filtered = category
    ? items.filter((i) => (i.category || "") === category)
    : items;

  return (
    <SearchableCombobox
      options={filtered}
      value={value}
      onPick={onPick}
      testId={testId}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      emptyLabel="No matching items."
      getId={(r) => r.id}
      getKey={(r) =>
        String(r.code || `name:${(r.name || "").toLowerCase()}`).trim()
      }
      getLabel={(r) => r.name || r.code || ""}
      getSecondary={(r) => {
        const base = `${r.code || "—"} · ${r.uom || "kg"}`;
        if (!showAvailability || r.available_qty === undefined) return base;
        return `${base} · avail ${Number(r.available_qty || 0).toLocaleString("en-IN")} ${r.uom || "kg"}`;
      }}
      getSearchFields={(r) => [r.name, r.code, r.hsn, r.barcode]}
    />
  );
}
